/* unplugin-vue-components disabled */import { render } from "./uselist.vue?vue&type=template&id=1b88c390"
import script from "./uselist.vue?vue&type=script&lang=js"
export * from "./uselist.vue?vue&type=script&lang=js"

import "./uselist.vue?vue&type=style&index=0&id=1b88c390&lang=css"
import "./uselist.vue?vue&type=style&index=1&id=1b88c390&lang=less"

import exportComponent from "/home/nightdays/app/code/vue/nb-recharge/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__